import { AxiosRequestConfig } from 'axios';
import { httpConfig } from 'src/lib/modules/http';
import { Api } from 'src/api';
import { ApiQueryObject } from '../../api-query-params';
import { PaginatedResponse } from 'src/api/Client';
import * as Types from './activities-export.types';

const baseUrl = `${httpConfig.options.baseURL}/company-request-action-snapshot-log-exports`;

const index = (
  config?: AxiosRequestConfig & {
    params?: ApiQueryObject;
  },
): Promise<PaginatedResponse<Types.ActivitiesExportResponse>> => Api.http.get(baseUrl, config);

const generate = (
  config?: AxiosRequestConfig & {
    params?: ApiQueryObject;
  },
): Promise<Types.ActivitiesExportResponse> => Api.http.post(baseUrl, {}, config);

const destroy = (model: string, config?: AxiosRequestConfig): Promise<void> =>
  Api.http.delete(`${baseUrl}/${model}`, config);

export * from './activities-export.types';
export { index, generate, destroy };
